import React, { useState, useEffect } from 'react';
import getSource from '../../utils/get-source';
import { getFooterLinks, isMobile } from '../../utils/utils';
import JioIcon from "../../images/JioIcon.svg"

export default ({ shouldHide }) => {
  const [sourceID, setSourceID] = useState('');
  useEffect(() => {
    (async () => {
      try {
        const data = await getSource();
        setSourceID(data.source_id);
      } catch (error) {
        console.error(error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderLinks = footerLists => (
    Object.entries(footerLists).map(([index, item]) => (
      <a
        href={item.value}
        style={{ marginRight: '10px', color: '#141414' }}
        target="_blank"
        rel="noopener noreferrer"
        key={index}
      >
        {item.key}
      </a>
    ))
  );
  return (
    shouldHide ? (<div style={{ display: 'none' }} />) : (
      <div style={{
        display: 'flex', color: '#000', width: '100%', justifyContent: 'space-around', fontSize: 14, position: 'fixed', bottom: 0, background: '#F5F5F5', height: `${window.innerWidth > 768 ? '65px' : '20px'}`, alignItems: 'center', borderTop: '1px solid #e0e0e0'
      }}
      >
        {window.innerWidth > 768 ? <div style={{ display: 'grid', width: '75%', gridTemplateColumns: '1fr 1fr' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <img src={JioIcon} alt="jio logo" style={{ width: '32px', height: '32px', marginRight: '8px', borderRadius: '50%' }} />
            <div style={{ fontSize: '12px', color: '#141414' }}>Copyright © 2022 Reliance Jio Infocomm Ltd. All rights reserved.</div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
            <div style={{ marginRight: '10px', color: '#141414' }}>
              {`v${global.appVersion}`}
            </div>
            <div style={{ marginRight: '10px', color: '#141414' }}>
              {renderLinks(getFooterLinks(sourceID))}
            </div>
          </div>
        </div> :
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
            <div style={{ marginRight: '10px', color: '#141414' }}>
              {`v${global.appVersion}`}
            </div>
            <div style={{ marginRight: '10px', color: '#141414' }}>
              {renderLinks(getFooterLinks(sourceID))}
            </div>
          </div>
        }
      </div>
    ));
};

